import {
    PATH_REPORT_DAILY_EXECUTION_SINGLE_VOYAGE,
    PATH_REPORT_EXECUTION_SINGLE_VOYAGE,
    PATH_REPORT_RFID_SINGLE_VOYAGE
} from "@constants/navigate";
import {IReportNavigateItemSingleVoyage} from "@pages/singleVoyage/reports/allReports/types";

export const ALL_REPORTS_NAVIGATE_SINGLE_VOYAGE: IReportNavigateItemSingleVoyage[] = [
    {
        label: 'singleVoyage.reportExecution',
        path: PATH_REPORT_EXECUTION_SINGLE_VOYAGE
    },
    {
        label: 'singleVoyage.reportRfid.title',
        path: PATH_REPORT_RFID_SINGLE_VOYAGE
    },
    {
        label: 'singleVoyage.reportDailyExecution.title',
        path: PATH_REPORT_DAILY_EXECUTION_SINGLE_VOYAGE
    },
]